// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchResultTitle_root___LjR8","count":"SearchResultTitle_count__Y3lZF"};